import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import React from 'react';
import { BhiDialog } from 'src/UIKit';
import { useBuilder } from './ContactCaptureBuilderContext';

export const DeleteContactCaptureDialog = () => {
  const {
    deleteContactCapture,
    deleteDialogOpen,
    deleting,
    name,
    setDeleteDialogOpen,
  } = useBuilder();

  return (
    <BhiDialog
      open={deleteDialogOpen}
      onClose={() => !deleting && setDeleteDialogOpen(false)}
      title="Delete contact capture?"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Typography variant="body2">
          {name || 'This contact capture'} and its analytics will be permanently removed.
          {' '}This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={deleting} onClick={() => setDeleteDialogOpen(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={deleting}
          onClick={() => void deleteContactCapture()}
        >
          {deleting ? 'Deleting…' : 'Delete'}
        </Button>
      </DialogActions>
    </BhiDialog>
  );
};
